<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="14" viewBox="0 0 28 14">
    <g transform="translate(-491 -70)">
      <g transform="translate(-770.898 -766.013)">
        <path
          d="M1286.9,847.988h-23l.037-.534a44.751,44.751,0,0,1,1.46-8.671l.661.03.253-.144a5.029,5.029,0,0,0,1.234.847c.767.443,2.307-.3,3.116-.795l-1.143-2.708,1.069.38a59.448,59.448,0,0,1,6.075,2.545,24.92,24.92,0,0,0,5.008,1.563,18.943,18.943,0,0,1,4.3,1.352c2.237,1.256,1.082,5.584,1.032,5.767Zm-21.922-1h21.147c.268-1.231.517-3.61-.647-4.264a18.666,18.666,0,0,0-4.038-1.251,25.505,25.505,0,0,1-5.219-1.639c-1.587-.771-3.229-1.478-4.89-2.1l.575,1.361-.332.232c-.295.2-2.923,1.989-4.526,1.059-.376-.217-.665-.4-.888-.554A43.713,43.713,0,0,0,1264.973,846.988Z"
        />
        <rect
          width="22.564"
          height="1"
          transform="translate(1264.478 844.534)"
        />
        <rect
          width="2.759"
          height="0.999"
          transform="translate(1273.683 840.962) rotate(-60.477)"
        />
        <rect
          width="2.484"
          height="1"
          transform="matrix(0.512, -0.859, 0.859, 0.512, 1275.777, 841.686)"
        />
      </g>
      <rect
        width="1"
        height="4"
        transform="translate(491 79)"
      />
      <rect
        width="1"
        height="4"
        transform="translate(518 79)"
      />
      <rect
        width="28"
        height="1"
        transform="translate(491 83)"
      />
    </g>
  </svg>
</template>
